import { render, staticRenderFns } from "./crudMethodsAcopio.vue?vue&type=template&id=7df0e1f4&"
import script from "./crudMethodsAcopio.vue?vue&type=script&lang=js&"
export * from "./crudMethodsAcopio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports